import { render } from "./PageViewsCard.vue?vue&type=template&id=97bbd008"
import script from "./PageViewsCard.vue?vue&type=script&lang=js"
export * from "./PageViewsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__